import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Page, ScenarioDeploy, ScenarioDeployBody } from "@/model";
import deployRepository from "@/repository/deployRepository";
import { deploymentQueryKeys } from "./keys";


export const useDeployScenario = (scenarioId: string) => {
    const queryClient = useQueryClient();
    
    return useMutation<Page<ScenarioDeploy>, Error, ScenarioDeployBody>({
        mutationKey: ['scenario-deploy', scenarioId, 'deploy'],
        mutationFn: async ({ version, description }) => {
            const response = await deployRepository.deploy(
                scenarioId, 
                version,
                description
            );
            return response.data;
        },
        onSuccess: async () => {
            await Promise.all([
                queryClient.invalidateQueries({ 
                    queryKey: deploymentQueryKeys.pageAll(scenarioId) 
                }),
                queryClient.invalidateQueries({ 
                    queryKey: deploymentQueryKeys.diffAll(scenarioId) 
                })
            ]);
        }
    });
};
